import { Linkedin, MapPin } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { cn } from "@/lib/utils";

const http = (u) => /^https?:\/\//i.test(String(u || ""));
export const profileUrl = (p) => [p.linkedin_url, p.profile_url, ...(p.profile_urls || []).filter((u) => /linkedin\.com/i.test(u)), ...(p.profile_urls || []), p.github_url, p.twitter_url, p.website].find(http) || null;
const liUrl = (p) => [p.linkedin_url, p.profile_url, ...(p.profile_urls || [])].find((u) => http(u) && /linkedin\.com/i.test(u)) || null;
const initials = (n) => String(n || "?").split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

// Hover preview (photo, headline, location) around a link to the person's profile. icon=true renders a small LinkedIn icon instead of the name.
export const ProfileLink = ({ p, url, icon, className, testid }) => {
  const href = url || (icon ? liUrl(p) : profileUrl(p));
  const name = p.full_name || p.name || [p.first_name, p.last_name].filter(Boolean).join(" ");
  if (!href) return icon ? null : <span className={className} data-testid={testid && `${testid}-plain`}>{name}</span>;
  const photo = [p.photo_url, p.avatar_url, p.image_url, p.picture].find(http);
  const head = p.headline || [p.title || p.current_title, p.company || p.company_name || p.current_employer].filter(Boolean).join(" at ");
  return (
    <HoverCard openDelay={250} closeDelay={80}>
      <HoverCardTrigger asChild>
        <a href={href} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} title={icon ? `Open ${name}'s profile` : undefined}
          className={cn(icon ? "inline-flex rounded p-1 text-zinc-500 transition-colors hover:text-[#60A5FA]" : "underline-offset-2 transition-colors hover:text-[#F3C649] hover:underline", className)} data-testid={testid}>
          {icon ? <Linkedin className="h-3.5 w-3.5" /> : name}
        </a>
      </HoverCardTrigger>
      <HoverCardContent side="top" align="start" onClick={(e) => e.stopPropagation()} className="w-72 border-[#27272A] bg-[#0f0f12]/95 p-3 backdrop-blur-xl" data-testid={testid && `${testid}-preview`}>
        <div className="flex gap-3">
          {photo ? <img src={photo} alt="" className="h-12 w-12 shrink-0 rounded-full border border-[#D4AF37]/40 object-cover" />
            : <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#D4AF37]/40 bg-[#1A1024] font-display text-sm font-semibold text-[#F3C649]">{initials(name)}</span>}
          <div className="min-w-0">
            <p className="truncate text-sm font-semibold text-zinc-50">{name}</p>
            {head && <p className="mt-0.5 line-clamp-2 text-xs text-zinc-300">{head}</p>}
            {p.location && <p className="mt-1 flex items-center gap-1 text-[11px] text-zinc-500"><MapPin className="h-3 w-3" />{p.location}</p>}
          </div>
        </div>
        <p className="mt-2 truncate border-t border-[#1f1f23] pt-2 text-[10px] text-[#c79bff]">{href.replace(/^https?:\/\/(www\.)?/, "")}</p>
      </HoverCardContent>
    </HoverCard>
  );
};
